<template>
  <div>
    <template v-if="loading"></template
    ><template v-else>
      <template v-if="type == 'inbox'">
        <report-message-graph
          :timestamp="timestamp"
          :intent-series="data[0]"
          :intent-chart-data="data[0].intents"
          :type="type"
          :date="date"
          :app="app"
          :fbpost="fbpost"
        ></report-message-graph>
      </template>
      <template v-else-if="type == 'comment'">
        <v-layout wrap>
          <template v-for="item in data">
            <v-flex :key="item.messagetype" xs12 sm6 md4>
              <report-message-graph
                :timestamp="timestamp"
                :intent-series="item"
                :intent-chart-data="item.intents"
                :type="type"
                :date="date"
                :app="app"
                :commenttype="item.messagetype"
                :post="post"
              ></report-message-graph>
            </v-flex>
          </template>
        </v-layout>
      </template>
    </template>
  </div>
</template>

<script>
import ReportMessageGraph from './ReportMessageGraph'

import { mapGetters } from 'vuex'

import moment from 'moment'
import numeral from 'numeral'
import * as XLSX from 'xlsx'
import analyticApi from '@/api/analytic'
import { handleResponse } from '@/api/util'

export default {
  components: {
    ReportMessageGraph
  },
  props: ['type', 'date', 'app', 'fbpost'],
  data() {
    return {
      data: [],
      loading: true,
      timestamp: moment().format('x')
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab'
    })
  },
  watch: {
    async app(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.selectedBot.status) {
          this.loading = true
          var response = await this.getIntent()
          this.formatData(response)
          this.loading = false
        } else {
          this.loadingIntent = false
          this.loading = false
        }
      }
    },
    async date(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.selectedBot.status) {
          this.loading = true
          var response = await this.getIntent()
          this.formatData(response)
          this.loading = false
        } else {
          this.loadingIntent = false
          this.loading = false
        }
      }
    }
  },
  async mounted() {
    if (this.selectedBot.status) {
      this.loading = true
      var response = await this.getIntent()
      this.formatData(response)
      this.loading = false
    } else {
      this.loadingIntent = false
      this.loading = false
    }
  },

  methods: {
    async getIntent() {
      let vm = this

      vm.loading = true

      if (this.type == 'inbox') {
        let config = {
          params: {
            pageid: this.selectedBot.pageid,
            datefrom: moment(this.date.start).format('YYYY-MM-DD'),
            dateto: moment(this.date.end).format('YYYY-MM-DD'),
            app: this.app
          }
        }
        const response = await analyticApi.getReportInbox({ config })
        await handleResponse(response)
        if (response.data.data) {
          this.total = response.data.total_message
          return response.data.data.sort(vm.sortIntent)
        }
      } else if (this.type == 'comment') {
        let config = {
          params: {
            page_id: this.selectedBot.pageid,
            from_date: moment(this.date.start).format('YYYY-MM-DD'),
            to_date: moment(this.date.end).format('YYYY-MM-DD'),
            app: this.app
          }
        }
        if (this.fbpost) {
          config.params.post_id = this.fbpost.id
        }
        const response = await analyticApi.getReportComment({ config })
        await handleResponse(response)
        if (response.data.data) {
          this.total = response.data.total_message

          return response.data.data.sort(vm.sortIntent)
        }
      }
    },
    formatData(data) {
      let conversations = {
        data: [],
        label: [],
        color: [],
        intentname: [],
        intents: []
      }
      if (data && data.length > 0) {
        conversations = data.map((val) => {
          let current_color = this.getRandomColor()
          const label = this.intentLabel(val['intent'])

          return {
            intent: {
              name: val['intent'],
              color: current_color,
              value: this.type == 'inbox' ? val['count'] : parseInt(val['intent_count'])
            },

            intentname: val['intent'],
            label: label,
            count: this.type == 'inbox' ? val['count'] : parseInt(val['intent_count']),
            color: current_color,
            messagetype: val.messagetype
          }
        })
      }

      if (this.type == 'inbox') {
        const data = this.formatDataAsSerie(conversations)
        this.data = []
        this.data.push({ ...data })
      } else {
        const replycomment =
            conversations && conversations.length
              ? conversations.filter((el) => el.messagetype == 'replycomment')
              : [],
          replyinbox =
            conversations && conversations.length
              ? conversations.filter((el) => el.messagetype == 'replyinbox')
              : [],
          hidecomment =
            conversations && conversations.length
              ? conversations.filter((el) => el.messagetype == 'hidecomment')
              : []
        const data = []
        data.push({ messagetype: 'replycomment', ...this.formatDataAsSerie(replycomment) })
        data.push({ messagetype: 'replyinbox', ...this.formatDataAsSerie(replyinbox) })
        data.push({ messagetype: 'hidecomment', ...this.formatDataAsSerie(hidecomment) })
        this.data = data
      }
      this.timestamp = moment().format('x')
      this.$emit('input', this.data)
    },
    formatDataAsSerie(conversations) {
      return conversations.reduce(
        (prev, curr) => {
          prev.data.push(curr.count)
          prev.label.push(curr.label)
          prev.intentname.push(curr.name)
          prev.color.push(curr.color)
          prev.intents.push(curr.intent)
          prev.count.push(curr.count)

          return prev
        },
        {
          data: [],
          label: [],
          intentname: [],
          color: [],
          intents: [],
          count: []
        }
      )
    },
    getRandomColor: function () {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    sortIntent: function (a, b) {
      if (parseInt(a.count) < parseInt(b.count)) return 1
      if (parseInt(a.count) > parseInt(b.count)) return -1
      return 0
    },

    exportDashboard: function () {
      let vm = this

      if (vm.loading) {
        return false
      }
      this.loading = true
      let json = []
      json.push([
        `${this.$t('from')} ` +
          moment(vm.date.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          moment(vm.date.end).format('DD/MM/YYYY')
      ])

      json.push([])
      json.push([this.$t('Conversation')])
      json.push(['Name', 'Count', 'Percent'])

      var totalIntentMessage = 0
      vm.intent.labels.forEach(function (seriesData, index) {
        totalIntentMessage += vm.intentSeries[index]
      })

      vm.intent.labels.forEach(function (seriesData, index) {
        json.push([
          seriesData,
          numeral(vm.intentSeries[index]).format('0,0'),
          (totalIntentMessage > 0
            ? numeral((vm.intentSeries[index] * 100) / totalIntentMessage).format('0.0')
            : 0) + ' %'
        ])
      })
      json.push([])
      json.push([])
      json.push([this.$t('Reply to inbox')])
      json.push(['Name', 'Count', 'Percent'])

      var totalCommentMessage = 0
      vm.comment.labels.forEach(function (seriesData, index) {
        totalCommentMessage += vm.commentSeries[index]
      })

      vm.comment.labels.forEach(function (seriesData, index) {
        json.push([
          seriesData,
          numeral(vm.commentSeries[index]).format('0,0'),
          (totalCommentMessage > 0
            ? numeral((vm.commentSeries[index] * 100) / totalCommentMessage).format('0.0')
            : 0) + ' %'
        ])
      })

      const dataWS = XLSX.utils.aoa_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwizdata-summary-conversation.xlsx')
      this.loading = false
    },
    toggleBotStatus: async function () {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/report/ReportMessage.vue